import net, { IRequestOptions, IRequestOptionsWithPass } from '@/services/net'
import { PackEntityCorpBalanceVO } from '../Type/PackEntityCorpBalanceVO'

interface DataModel {
	cid?: string
}

/**
 *	根据cid查询用户相关余额信息
 * @param {DataModel} [data] 封装对象
 * @param {string} [data.cid] 企业id
 */

export function queryBalanceInfo(data: DataModel, options: IRequestOptionsWithPass): Promise<PackEntityCorpBalanceVO>
export function queryBalanceInfo(
	data: DataModel,
	options?: IRequestOptions,
): Promise<PackEntityCorpBalanceVO extends { msg: unknown } ? PackEntityCorpBalanceVO['msg'] : undefined>
export function queryBalanceInfo(data: DataModel, options: IRequestOptionsWithPass | IRequestOptions = {}) {
	const { cid } = data
	return net('/frontApi/cust/queryBalanceInfo', {
		method: 'post',
		params: {
			cid,
		},

		...(options || {}),
	})
}
